import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { VehicleTypeService } from '../type-vehicle.service';
import VehicleTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity';
import { LOCALIZED_PROPERTIES, VEHICLE_TYPE_EXPORT_ID, VEHICLE_TYPE_TITLE } from './type-vehicle.constants';

@Injectable()
export class VehicleTypeExport {
  constructor(
    private exportService: ExportService,
    private vehicleTypeService: VehicleTypeService,
  ) {}

  private transformItem(item: VehicleTypeAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      capacity: get(item, 'capacity', '??'),
      company: get(item, 'company.name', '??'),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: VEHICLE_TYPE_EXPORT_ID,
      title: VEHICLE_TYPE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(VEHICLE_TYPE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.vehicleTypeService.findByFilter(buildQuery(
          seed(this.vehicleTypeService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(VEHICLE_TYPE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(VEHICLE_TYPE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
